import { Paragraph } from "@datagame/ui";
import classNames from "classnames/bind";

import styles from "./EmptyList.module.scss";

const cx = classNames.bind(styles);

export const EmptyRow = ({ className }: { className?: string }) => {
  return (
    <div className={cx("emptyRow", className)}>
      <div className={cx("emptyItem", "big")}></div>
      <div className={styles.emptyItemsWrapper}>
        <div className={cx("emptyItem", "small")}></div>
        <div className={cx("emptyItem", "small")}></div>
        <div className={cx("emptyItem", "gray", "small")}></div>
      </div>
    </div>
  );
};

export interface EmptyListProps {
  title: string;
  description: string;
}

export const EmptyList = ({ title, description }: EmptyListProps) => {
  return (
    <div className={styles.emptyWrapper}>
      <EmptyRow />
      <EmptyRow />
      <EmptyRow className={styles.transformed} />

      <Paragraph size="large" weight="font-bold" className={styles.emptyTitle} color="secondary">
        {title}
      </Paragraph>

      <Paragraph className={styles.emptyDescription}>{description}</Paragraph>
    </div>
  );
};
